module.exports = __webpack_public_path__ + "img/orders-process.2779fa72.svg";